export default __webpack_public_path__ + "static/talking-background-651a996ec1b9e1d44bdb8ddfba7fec86.png";